import { JSX } from "react";

import { IconProps } from "@/@types/general.ts";

const IconGoogle = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M28 16.2667C28 15.28 27.9183 14.56 27.7415 13.8133H16.2449V18.2666H22.9931C22.8571 19.3733 22.1224 21.04 20.4898 22.1599L20.4669 22.309L24.1019 25.0687L24.3537 25.0933C26.6666 23 28 19.92 28 16.2667Z"
      fill="#4285F4"
    />
    <path
      d="M16.2449 28C19.551 28 22.3265 26.9333 24.3537 25.0933L20.4898 22.1599C19.4558 22.8666 18.068 23.3599 16.2449 23.3599C13.0068 23.3599 10.2585 21.2667 9.27886 18.3733L9.13526 18.3853L5.35552 21.252L5.30609 21.3866C7.31968 25.3066 11.4557 28 16.2449 28Z"
      fill="#34A853"
    />
    <path
      d="M9.27886 18.3733C9.02036 17.6267 8.87076 16.8266 8.87076 16C8.87076 15.1733 9.02036 14.3733 9.26526 13.6267L9.25841 13.4676L5.43131 10.5549L5.30609 10.6133C4.4762 12.24 4 14.0667 4 16C4 17.9333 4.4762 19.7599 5.30609 21.3866L9.27886 18.3733Z"
      fill="#FBBC05"
    />
    <path
      d="M16.2449 8.63997C18.5442 8.63997 20.0952 9.6133 20.9796 10.4267L24.4353 7.12C22.3129 5.18667 19.551 4 16.2449 4C11.4557 4 7.31968 6.69331 5.30609 10.6133L9.26526 13.6267C10.2585 10.7333 13.0068 8.63997 16.2449 8.63997Z"
      fill="#EB4335"
    />
  </svg>
);

export default IconGoogle;
